import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "NotFound" */ '../views/elements/404.vue')
    },
    {
        path: '/',
        name: 'HomeStartUp',
        component: () => import(/* webpackChunkName: "HomeStartUp" */ '../views/HomeStartUp.vue'),
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import(/* webpackChunkName: "PrivacyPolicy" */ '../views/pages/PrivacyPolicy.vue'),
    },
    {
        path: '/impressum',
        name: 'Impressum',
        component: () => import(/* webpackChunkName: "Impressum" */ '../views/pages/Impressum.vue'),
    },
    {
        path: '/kurs1',
        name: 'Kurs1',
        component: () => import(/* webpackChunkName: "Kurs1" */ '../views/pages/Kurs1.vue'),
    },
    {
        path: '/kurs2',
        name: 'Kurs2',
        component: () => import(/* webpackChunkName: "Kurs2" */ '../views/pages/Kurs2.vue'),
    },
    {
        path: '/kurs3',
        name: 'Kurs3',
        component: () => import(/* webpackChunkName: "Kurs3" */ '../views/pages/Kurs3.vue'),
    },
    {
        path: '/kurs4',
        name: 'Kurs4',
        component: () => import(/* webpackChunkName: "Kurs4" */ '../views/pages/Kurs4.vue'),
    },
    {
        path: '/kurs5',
        name: 'Kurs5',
        component: () => import(/* webpackChunkName: "Kurs5" */ '../views/pages/Kurs5.vue'),
    },
    {
        path: '/kurs6',
        name: 'Kurs6',
        component: () => import(/* webpackChunkName: "Kurs6" */ '../views/pages/Kurs6.vue'),
    },
    {
        path: '/kurs7',
        name: 'Kurs7',
        component: () => import(/* webpackChunkName: "Kurs7" */ '../views/pages/Kurs7.vue'),
    },
    {
        path: '/kurs8',
        name: 'Kurs8',
        component: () => import(/* webpackChunkName: "Kurs8" */ '../views/pages/Kurs8.vue'),
    },
    {
        path: '/kurs9',
        name: 'Kurs9',
        component: () => import(/* webpackChunkName: "Kurs9" */ '../views/pages/Kurs9.vue'),
    },
    {
        path: '/kurs10',
        name: 'Kurs10',
        component: () => import(/* webpackChunkName: "Kurs10" */ '../views/pages/Kurs10.vue'),
    },
    {
        path: '/FunnelGastro',
        name: 'FunnelGastro',
        component: () => import(/* webpackChunkName: "FunnelGastro" */ '../views/pages/FunnelGastro.vue'),
    },
    {
        path: '/AboutUs',
        name: 'AboutUs',
        component: () => import(/* webpackChunkName: "AboutUs" */ '../views/pages/AboutUs.vue'),
    },
    {
        path: '/AboutTeacher',
        name: 'AboutTeacher',
        component: () => import(/* webpackChunkName: "AboutTeacher" */ '../views/pages/AboutDozenten.vue'),
    },
];
  
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
          return window.scrollTo({ 
            top: document.querySelector(to.hash).offsetTop, 
            behavior: 'smooth' 
          })
        } else {
          return { x: 0, y: 0 }
        }
      }
});
  
export default router;
